import Vue from 'vue'
import Vuex from 'vuex'
import chat, { STORAGE_KEY } from './modules/chat'

Vue.use(Vuex)

// Serializa el hilo del chat a sessionStorage en cada mutación del módulo `chat`,
// para que la conversación sobreviva a la navegación y a las recargas durante la visita.
const persistChat = (store) => {
  store.subscribe((mutation, state) => {
    if (!mutation.type.startsWith('chat/')) return
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        messages: state.chat.messages,
        lastProperties: state.chat.lastProperties,
        sessionId: state.chat.sessionId,
        isPanelOpen: state.chat.isPanelOpen
      }))
    } catch (e) {
      // sessionStorage puede estar bloqueado (modo privado): el chat sigue en memoria
    }
  })
}

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    chat
  },
  plugins: [persistChat]
})
